// Generated by CoffeeScript 2.7.0
var FormableMixin;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import Attachments from 'trunks/vue/admin/components/libs/attachments.js';

export default FormableMixin = {
  components: {
    'attachments': Attachments
  },
  props: ['resource', 'type'],
  data: function() {
    return {
      attachments: [],
      errors: {}
    };
  },
  created: function() {
    var _attachments;
    _attachments = this[this.type].attachments || [];
    this[this.type].attachment_ids = _.map(_attachments, function(attachment) {
      return attachment.id;
    });
    return this.attachments = new Skylark.Libs.Storage.Attachments(_attachments).files;
  },
  mounted: function() {
    return new Skylark.Elements.FixedPosition(this.$refs.formableActions);
  },
  methods: {
    save: function() {
      var options;
      options = this._getSaveOptions();
      if (!this.isValid(options.data[this.type])) {
        return;
      }
      options.data[this.type].status = 'published';
      return Skylark.Libs.Ajax[options.method](options.url, {
        data: options.data,
        contentType: "application/json; charset=UTF-8",
        success: (formable, status, xhr) => {
          return this.afterSaved(formable);
        },
        error: (xhr, status) => {
          return newAlertify('发布失败', {
            type: 'error',
            description: this._parseErrorFromServer(JSON.parse(xhr.response))
          });
        }
      });
    },
    saveAsDraft: function() {
      var options;
      options = this._getSaveOptions();
      options.data[this.type].status = 'drafted';
      return Skylark.Libs.Ajax[options.method](options.url, {
        data: options.data,
        contentType: "application/json; charset=UTF-8",
        success: (formable, status, xhr) => {
          newAlertify('保存成功', {
            type: 'success'
          });
          return Turbolinks.visit(`/admin/${this.type}s/drafted`);
        },
        error: (xhr, status) => {
          return newAlertify('保存失败', {
            type: 'error',
            description: this._parseErrorFromServer(JSON.parse(xhr.response))
          });
        }
      });
    },
    afterSaved: function(formable) {
      return Turbolinks.visit(`${this.resource}/${formable.id}`);
    },
    removeAttachment: function(index) {
      var callbacks, file, ref;
      file = this.attachments[index];
      callbacks = {
        success: (error, xhr) => {
          if (error) {
            return;
          }
          return this.attachments.splice(index, 1);
        },
        error: function(error, xhr) {
          return console.log(error.message);
        }
      };
      if (file.id) {
        return Skylark.Libs.Storage.Attachment.Delete(file.id, callbacks);
      } else {
        if ((ref = this._prepAttachments) != null) {
          ref.removeItem(file);
        }
        return this.attachments.splice(index, 1);
      }
    },
    reloadAttachment: function(index) {
      var file;
      file = this.attachments[index];
      file._error_message = '';
      this.uploading = true;
      return file.upload({
        error: function(error, xhr) {
          return file._error_message = error.message;
        },
        progress: function(error, percentage) {
          return file._progress = percentage;
        },
        complete: () => {
          this.uploading = false;
          return file._progress = 0;
        }
      });
    },
    addAttachments: function(event) {
      this._prepAttachments = new Skylark.Libs.Storage.Attachments(event.target.files);
      this.attachments.splice.apply(this.attachments, [this.attachments.length, 0].concat(this._prepAttachments.files));
      this.uploading = true;
      return this._prepAttachments.upload({
        complete: (attachment) => {
          return this[this.type].attachment_ids.push(attachment.id);
        },
        uploadCompleted: () => {
          event.target.value = null;
          this._prepAttachments = null;
          return this.uploading = false;
        }
      });
    },
    isValid: function(data) {
      if (data == null) {
        data = this.getData();
      }
      if (!data.title) {
        return false;
      }
      return true;
    },
    validateTitle: function() {
      var base;
      if (_.isEmpty(this[this.type].title.trim())) {
        if ((base = this.errors).title == null) {
          base.title = [];
        }
        return this.errors.title.push('不能为空');
      }
    },
    validateBody: function(html_body) {
      var base;
      if (html_body === '<p></p>') {
        if ((base = this.errors).html_body == null) {
          base.html_body = [];
        }
        return this.errors.html_body.push('不能为空');
      }
    },
    validateBlankPage: function() {
      var base, has_blank_page;
      has_blank_page = this.$refs.fieldsView.checkBlankPage();
      if (has_blank_page) {
        if ((base = this.errors).page == null) {
          base.page = [];
        }
        return this.errors.page.push('内容为空');
      }
    },
    validate: function() {
      this.errors = {};
      return this._validate();
    },
    _validate: function() {
      this.validateTitle();
      return this.validateBody(this.$refs.editor.getValue());
    },
    parseErrors: function() {
      var error_message;
      this.validate();
      error_message = [];
      _.each(this.errors, function(error, key) {
        return _.each(error, function(value) {
          if (key === 'page') {
            return error_message.push('存在' + Skylark.Helpers.translate('message.' + key) + value);
          } else {
            return error_message.push(Skylark.Helpers.getZH_CN('message.' + key) + value);
          }
        });
      });
      return error_message.join(',');
    },
    afterValidate: function(action, callback) {
      var error_messages;
      error_messages = this.parseErrors();
      if (_.isEmpty(error_messages)) {
        return typeof callback === "function" ? callback(action) : void 0;
      } else {
        return newAlertify(`${Skylark.Helpers.getZH_CN('message.actions.' + action)}失败`, {
          type: 'error',
          description: error_messages
        });
      }
    },
    _getAttachment_ids: function() {
      return _.chain(this.attachments).filter(function(attachment) {
        return attachment.id;
      }).pluck('id').value();
    },
    _parseErrorFromServer: function(error) {
      return _.chain(error.errors).map(function(_error) {
        return _error.details.join(', ');
      }).value().join(', ');
    },
    _getSaveOptions: function() {
      var options;
      options = {
        data: {}
      };
      if (this[this.type].id) {
        options.method = 'patch';
        options.url = Skylark.Helpers.UrlHelper.extendJSON(`${this.resource}/${this[this.type].id}`);
      } else {
        options.method = 'post';
        options.url = Skylark.Helpers.UrlHelper.extendJSON(this.resource);
      }
      options.data = this.getData();
      return options;
    }
  }
};
